export const CMS_BANNER_THEME_TYPES = ['dark', 'white', 'brand', 'yellow'];
